import React from 'react'
import PropTypes from 'prop-types'
import { ItemContent, ITEM_POSITIONS, ThemeColorContext } from 'shared/Components/ItemContent'
import { ItemContentHandlerRenderer } from 'LiveBoard/components/shared/ItemContentHandlerRenderer'
import { Header } from './Header'
import CallToActionContainer from 'LiveBoard/containers/CallToActionContainer'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'
import { NavigationPanel } from './NavigationPanel'
import { SellerCard } from '../SellerCard'
import ItemViewerWrapper from './ItemViewerWrapper'
import { getItemTypeConfig } from 'LiveBoard/components/shared/ItemType'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import isEqual from 'lodash/isEqual'
import get from 'lodash/get'

import './style.css.scss'

class ItemViewer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSellerCardOpen: false,
      menuItems: {}
    }
  }

  componentDidMount() {
    this.setState({ menuItems: this.getMenuItems() })
  }

  componentDidUpdate(prevProps, prevState) {
    if(!isEqual(prevProps.currentItem, this.props.currentItem) ||
       !isEqual(prevProps.blockDownload, this.props.blockDownload)) {
      this.setState({ menuItems: this.getMenuItems() })
    }
  }

  getPositionFor = (itemIndex) => {
    const {
      items: { prevItemIndex, currentItemIndex, nextItemIndex }
    } = this.props

    switch (itemIndex) {
      case prevItemIndex:
        return ITEM_POSITIONS.previous
      case nextItemIndex:
        return ITEM_POSITIONS.next
      case currentItemIndex:
        return ITEM_POSITIONS.current
    }
  }

  handleCancelGating = () => {
    if(this.props.gatingConfig.is_mandatory) {
      this.props.onClose()
    }
  }

  handleNextItem = () => {
    this.props.onNextItem()
  }

  handlePrevItem = () => {
    this.props.onPrevItem()
  }

  togglePanel = () => {
    this.setState({isSellerCardOpen: !this.state.isSellerCardOpen})
  }

  isVideoItem = (item) => {
    const itemTypeConfig = getItemTypeConfig(item)
    return itemTypeConfig.isVideo || itemTypeConfig.isLinkAsVideo
  }

  getMenuItems = () => {
    const {
      currentItem, onOpenInNewTab, onLike, onDownload,
      getTranslation, blockDownload
    } = this.props

    const itemConfig = !!currentItem && getItemTypeConfig(currentItem, blockDownload)

    return {
      newTab: {
        iconClass: 'icon-new-tab',
        label: getTranslation(TRANSLATION_VALUE_KEYS.openNewTab),
        onClick: onOpenInNewTab,
        shouldDisplay: get(itemConfig, "canOpenInNewTab", false)
      },
      download: {
        iconClass: 'icon-download',
        label: getTranslation(TRANSLATION_VALUE_KEYS.download),
        onClick: onDownload,
        shouldDisplay: get(itemConfig, "canDownload", false)
      },
      like: {
        iconClass: 'icon-like-empty',
        label: getTranslation(TRANSLATION_VALUE_KEYS.like),
        onClick: onLike,
        shouldDisplay: this.props.showLikes && !get(currentItem, "liked_by_user", true)
      },
      likeFull: {
        iconClass: 'icon-like-full',
        shouldDisplay: this.props.showLikes && get(currentItem, "liked_by_user", false)
      }
    }
  }

  render() {
    const { currentItem, themeColorHex, nextItemUrl, prevItemUrl } = this.props
    const { data, currentItemId } = this.props.items
    const { isSellerCardOpen } = this.state
    const showContactCard = this.props.contactCard.card.show
    const showSellerCard = isSellerCardOpen ? 'with-seller-card' : ''

    return isEmpty(currentItem) ? (
      <ItemViewerWrapper
        bannerHeight={this.props.bannerHeight} />
    ) : (
      <>
        <ItemViewerWrapper
          bannerHeight={this.props.bannerHeight}
          isVideoItem={this.isVideoItem(currentItem)} >
          <Header
            item={currentItem}
            isVideoItem={this.isVideoItem(currentItem)}
            themeColorHex={themeColorHex}
            isClassicTheme={this.props.isClassicTheme} />
          {
            map(data, (item) => {
              return (
                <ItemContentHandlerRenderer key={item.journey_index}>
                  <ItemContent
                    key={item.journey_index}
                    item={item}
                    themeColorHex={themeColorHex}
                    itemPosition={this.getPositionFor(item.journey_index)}
                    requireSsl={this.props.requireSsl}
                    contentItemId={item.content_item_id}
                    onClick={this.props.onClickItem}
                    isVideoItem={this.isVideoItem(currentItem)} />
                </ItemContentHandlerRenderer>
              )
            })
          }
          { this.props.isGated && (
            <CallToActionContainer
              config={this.props.gatingConfig}
              area={CTA_AREAS.gating}
              themeColorHex={themeColorHex}
              autoOpenOnRender={true}
              onCancel={this.handleCancelGating}
              itemId={currentItemId}
              ctaClass='gating-form' />
          )}
        </ItemViewerWrapper>
        <div className={`nav-wrapper ${showSellerCard}`}>
          <NavigationPanel
            onNextItem={this.handleNextItem}
            onPrevItem={this.handlePrevItem}
            hasNavigation={this.props.itemsCount > 1 && this.props.hasNavigation}
            onSellerClick={this.togglePanel}
            seller={this.props.seller}
            showSeller={this.props.isClassicTheme && showContactCard}
            showActionButtons={!this.props.isClassicTheme}
            actionButtons={this.state.menuItems}
            themeColorHex={themeColorHex}
            nextItemUrl={nextItemUrl}
            prevItemUrl={prevItemUrl} />
        { !!showContactCard &&
          !!this.props.isClassicTheme &&
          <SellerCard
            config={this.props.contactCard.card}
            themeColorHex={themeColorHex}
            seller={this.props.seller}
            onClick={this.togglePanel}
            expandCard={true} /> }
        </div>
      </>
    )
  }
}

ItemViewer.propTypes = {
  items: PropTypes.object.isRequired,
  currentItem: PropTypes.object,
  gatingConfig: PropTypes.object.isRequired,
  isGated: PropTypes.bool.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  contactCard: PropTypes.object.isRequired,
  header: PropTypes.object.isRequired,
  bannerHeight: PropTypes.string,
  lead: PropTypes.object.isRequired,
  onLike: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onOpenInNewTab: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onNextItem: PropTypes.func,
  onPrevItem: PropTypes.func,
  provideViewerContainer: PropTypes.func,
  seller: PropTypes.object.isRequired,
  requireSsl: PropTypes.bool,
  onClickItem: PropTypes.func,
  blockDownload: PropTypes.bool,
  isClassicTheme: PropTypes.bool.isRequired,
  hasNavigation: PropTypes.bool.isRequired,
  nextItemUrl: PropTypes.string.isRequired,
  prevItemUrl: PropTypes.string.isRequired,
  showLikes: PropTypes.bool
}

export default withTranslation(TRANSLATION_KEYS.mobileItemsHeader)(ItemViewer)
